"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var one_server_only_native_exports = {};
__export(one_server_only_native_exports, {
  asyncHeadersCache: () => asyncHeadersCache,
  ensureAsyncLocalID: () => ensureAsyncLocalID,
  getServerContext: () => getServerContext,
  getServerData: () => getServerData,
  mergeHeaders: () => mergeHeaders,
  requestAsyncLocalStore: () => requestAsyncLocalStore,
  runWithAsyncLocalContext: () => runWithAsyncLocalContext,
  setResponseHeaders: () => setResponseHeaders,
  setServerContext: () => setServerContext,
  setServerData: () => setServerData,
  useServerContext: () => useServerContext
});
module.exports = __toCommonJS(one_server_only_native_exports);
var requestAsyncLocalStore = null;
var asyncHeadersCache = /* @__PURE__ */ new WeakMap();
async function setResponseHeaders(cb) {
}
function mergeHeaders(onto, from) {
}
function ensureAsyncLocalID() {
}
async function runWithAsyncLocalContext(cb) {
}
function setServerContext() {
}
function setServerData() {
}
function getServerContext() {
}
function useServerContext() {
}
function getServerData() {
}
//# sourceMappingURL=one-server-only.native.js.map
